import { BPButton } from '@/components/bp/bpbutton';
import * as React from 'react';
import { Button, Icon } from 'semantic-ui-react';

interface ICopyToClipboardProps {
    children: React.ReactNode;
}

export const CopyToClipboard: React.FunctionComponent<ICopyToClipboardProps> = (props) => {
    const inputRef = React.useRef<HTMLElement>(null)  
    return <>
        <div style={{ position: 'relative', paddingRight: '50px', display: 'block', height: '2em', overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'keep-all', whiteSpace: 'nowrap' }}>
            <span ref={inputRef}>{props.children}</span>
            <div style={{ position: 'absolute', right: 0, top: 0 }}>
                <BPButton size='tiny' basic icon={'copy'} compact onClick={() => {
                    copyWithStyle(inputRef.current);
                }}></BPButton>
            </div>
        </div>

    </>;
};

export const copyWithStyle = (element: HTMLElement) => {

    const doc = document;
    const text = element;
    let range;
    let selection;

    selection = window.getSelection();

    range = doc.createRange();
    range.selectNodeContents(text);

    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
    window.getSelection().removeAllRanges();
}
